import { useEffectOnce } from 'react-use';

import { useRequestLoaderContext } from 'applications/GSP/app/providers/PrefetchProvider/hooks/useRequestLoaderContext';
import { useLazyGetApiSchoolSettingsQuery } from 'applications/GSP/shared/api/gsp';

import { useSetFavicon } from './hooks';

export const useGetSchool = () => {
  const [, setIsLoadingRequests] = useRequestLoaderContext();
  const [getSchoolSettings] = useLazyGetApiSchoolSettingsQuery();

  useEffectOnce(() => {
    getSchoolSettings().finally(() => {
      setIsLoadingRequests(prevState => ({
        ...prevState,
        isSchoolSettingsLoading: false,
      }));
    });
  });

  useSetFavicon();
};
